"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Contract_Signer = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Coding_1 = require("./RTTI_Coding");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_Signature_1 = require("./RTTI_Signature");
exports.RTTI_Contract_Signer = t.recursion('IContract_Signer', function () {
    return t.intersection([
        t.type({
            type: RTTI_Coding_1.RTTI_Coding,
            party: RTTI_Reference_1.RTTI_Reference,
            signature: t.array(RTTI_Signature_1.RTTI_Signature)
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension)
        })
    ]);
});
//# sourceMappingURL=RTTI_Contract_Signer.js.map